import { render, staticRenderFns } from "./ProductionDHR.vue?vue&type=template&id=54c9da5b&scoped=true&"
import script from "./ProductionDHR.vue?vue&type=script&lang=js&"
export * from "./ProductionDHR.vue?vue&type=script&lang=js&"
import style0 from "./ProductionDHR.vue?vue&type=style&index=0&id=54c9da5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c9da5b",
  null
  
)

export default component.exports